// Usage: https://github.com/Akryum/floating-vue
import Vue from 'vue'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import '@/assets/stylesheets/common/floating-vue.styl'

Vue.use(FloatingVue)
